export default __webpack_public_path__ + "static/media/accident.d44a4ccc.svg";